(function() {
  /** Show cookie banner if cookie is not set */
  if (document.cookie.replace(/(?:(?:^|.*;\s*)cookie_law_test4\s*=\s*([^;]*).*$)|^.*$/, '$1') !== 'trusted') {
    document.getElementById('cookie-banner').classList.remove('is-hidden');
  }
  /**
   * Set cookie and hide banner
   * @param {MouseEvent} e
   */
  function setCookie(e) {
    e.preventDefault();
    document.cookie = 'cookie_law_test4=trusted';
    document.getElementById('cookie-banner').classList.add('is-hidden');
  }
  document.getElementById('cookie-button').addEventListener('click', setCookie);
})();



// WEBPACK FOOTER //
// ./scripts/components/CookieBanner.js